import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Hide, Image, Copy, QR as QRCode } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import { APPLICATION, TRADENAME } from 'commons/js/constants'
import { useApi } from '@elparking/utils'
import PlaceholderContainer from 'commons/js/ui/PlaceholderContainer'
import LoaderButton from 'commons/js/ui/LoaderButton'
import { createDeepLink } from 'commons/js/api'

const DownloadAppBlock = ({onAccept, bookingId, createDeepLink}) => {
    const {
        response: { result: firebaseBaseUrl, error: firebaseBaseUrlError },
        loading: firebaseBaseUrlLoading,
        sendRequest: getRentalCarBookingDeepLink,
    } = useApi(createDeepLink)

    useEffect(() => {
        getRentalCarBookingDeepLink({
            name: 'RentalCarBooking',
            parameters: {
                application: APPLICATION,
                bookingId,
            },
        })
    }, [bookingId, getRentalCarBookingDeepLink])

    return <Flex mt={['0px', '3em']} flexDirection='column' textAlign='center' padding='1em'>
        <Hide md lg><Image src='/images/rental-car/download-app.svg' width='200px' height='200px' alignSelf='center' alt='Download app' /></Hide>
        <Copy size={['large', 'xxLarge']} fontWeight='medium' padding='1em 0em' fontColor='accent_dark'>
            <FormattedMessage defaultMessage='Consulta y gestiona tu reserva desde la app de {tradename}' values={{tradename: TRADENAME}}/>
        </Copy>
        <Copy padding='1em 0em' fontWeight='regular'>
            <FormattedMessage defaultMessage='Descárgate la app de {tradename} para consultar, editar o cancelar tu reserva.' values={{tradename: TRADENAME}}/>
        </Copy>
        <Copy fontWeight='regular'>
            <FormattedMessage defaultMessage='Tampoco necesitarás imprimirla para llevarla contigo.'/>
        </Copy>

        {!firebaseBaseUrlError &&
        <>
            <Hide xs sm>
                {!firebaseBaseUrl || firebaseBaseUrlLoading
                         ? <PlaceholderContainer><Box padding='1em 0em' margin='auto' backgroundColor='gray60' height={160} width={160} /></PlaceholderContainer>
                      : <>
                          <Box dataTest='qr-booking-detail' width='100%' padding='1em 0em'>
                              <QRCode value={firebaseBaseUrl} size={160}/>
                          </Box>
                          <Copy fontSize='xSmall' fontWeight='book' mb='2em'>
                              <FormattedMessage defaultMessage='Disponible para iOS y Android'/>
                          </Copy>
                      </>
                    }
            </Hide>
            <Hide md lg>
                <Flex width={['100%', 'fit-content']} alignSelf='center' flexDirection='column' alignContent='center' mt='1em' mb={['0em', '1em']}>
                    <LoaderButton loading={firebaseBaseUrlLoading} as='a' href={firebaseBaseUrl} onClick={onAccept} alignContent='center' height='100%' fontWeight='book' target='_blank' rel='noopener noreferrer' fontSize='small' padding='1em'>
                        <FormattedMessage defaultMessage='Descargar App' />
                    </LoaderButton>
                </Flex>
            </Hide>
        </>
            }
    </Flex>
}

DownloadAppBlock.propTypes = {
    onAccept: PropTypes.func,
    bookingId: PropTypes.number,
    createDeepLink: PropTypes.func.isRequired,
}

DownloadAppBlock.defaultProps = {
    createDeepLink,
}

export default DownloadAppBlock
